import React from "react";
import * as moment from "moment";
import * as _ from "lodash";
import {
    useTable,
    usePagination,
    useSortBy,
    useFilters,
    useGroupBy,
    useExpanded,
    useRowSelect,
} from "react-table";
import bootbox from "bootbox";

import { ModelApi } from "../api/modelApi";
import { UiUtils } from "../common/uiUtils";

const sdHref = (model) => {
    return `/sd/combined/${model.queryId}`;
}

const ModelRow = (props) => {
    const { row } = props;

    return <tr
               {...row.getRowProps()}>
               {row.cells.map(cell => {
                   return (
                       <td
                           {...cell.getCellProps()}
                           style={{
                               padding: "10px",
                               border: "solid 1px gray",
                           }}>
                           {cell.render("Cell")}
                       </td>
                   );
               })}
           </tr>;
}

const ComboModelList = (props) => {
    const [models, setModels] = React.useState([]);
    const [pending, setPending] = React.useState(false);

    const fetchModels = async () => {
        setPending(true);
        const { data } = await ModelApi.getComboModels(props.group, props.projectId);
        setModels(data);
        setPending(false);
    }

    React.useEffect(() => {
            fetchModels();
        },
        []);

    const data = React.useMemo(() => models, [models]);
    const columns = React.useMemo(() => _.compact([
        {
            Header: "Name",
            accessor: "name",
            Cell: ({ value, row }) => {
                return <a href={sdHref(row.original)} target="_blank">{value}</a>;
            }
        },
        {
            Header: "Created",
            accessor: "creationDate",
            Cell: ({ value }) => UiUtils.formatDateTime(value)
        },
        {
            Header: "Expires",
            accessor: "expirationDate",
            Cell: ({ value }) => UiUtils.formatDateTime(value)
        },
        props.authenticated && props.enableDelete
            ? {
                Header: "",
                accessor: "id",
                Cell: ({ value, row }) =>
                    <button className="btn btn-danger btn-sm" disabled={pending} onClick={() => {
                        bootbox.confirm(`Do you really want to delete the model ${row.original.name}?`,
                            async (result) => {
                                if (result) {
                                    try {
                                        setPending(true);
                                        await ModelApi.deleteComboModel("default", props.projectId, value);
                                        UiUtils.notifySuccess("Model deleted.");
                                        setPending(false);
                                    } finally {
                                        await fetchModels();
                                    }
                                }
                            });
                    }}>
                        <span className="icon ion-md-trash"></span>
                    </button>
            } : null
    ]), [pending]);

    const pageSizeOptions = [10, 20, 50, "all"];

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        gotoPage,
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable({ columns, data }, usePagination);

    return (
        <div key="modelList" className="row mb-3">
            <div className="col">
                <div className="row">
                    <div className="col">
                        <h5>Combined models</h5>
                    </div>
                </div>
                <div className="row">
                    {_.isEmpty(rows) && <div className="col">No combined models</div>}
                    {!_.isEmpty(rows) && <div className="col">
                        <div className="row no-gutters">
                            <table className="table">
                                <thead>
                                {headerGroups.map(headerGroup => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map((column, index) => (
                                        <th
                                            {...column.getHeaderProps()}
                                            style={{
                                                borderBottom: "solid 3px",
                                                color: "black",
                                                fontWeight: "bold",
                                            }}>
                                            {column.render("Header")}
                                        </th>
                                    ))}
                                    </tr>
                                ))}
                                </thead>
                                <tbody {...getTableBodyProps()}>
                                {pending && <tr><td colSpan={4}><p className="pending"><span>.</span><span>.</span><span>.</span></p></td></tr>}
                                {page.map(row => {
                                    prepareRow(row);
                                    return (
                                        <ModelRow key={row.original.id} row={row}/>
                                    );
                                })}
                                </tbody>
                            </table>
                        </div>
                        <form>
                            <div className="form-row justify-content-start no-gutters">
                                <div className="col-md-auto">
                                    <button type="button" className="btn btn-primary" onClick={() => previousPage()} disabled={
!canPreviousPage}>
                                        {"<"}
                                    </button>
                                </div>
                                <div className="col-md-auto">
                                    <span style={{ verticalAlign: "middle" }}>
                                        {pageIndex + 1} / {pageOptions.length}
                                    </span>
                                </div>
                                <div className="col-md-auto">
                                    <button type="button" className="btn btn-primary ml-1" onClick={() => nextPage()
} disabled={!canNextPage}>
                                        {">"}
                                    </button>
                                </div>

                                <div className="col-md-auto">
                                    <input
                                        className="form-control"
                                        type="number"
                                        placeholder="Go to page"
                                        onChange={e => {
                                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                    gotoPage(page);
                                }}/>
                                </div>
                                <div className="col-md-auto">
                                    <select
                                        className="form-control"
                                        value={pageSize}
                                        onChange={e => {
                                    setPageSize(Number(e.target.value));
                                }}>
                                        {pageSizeOptions.map(pageSize => (
                                            <option key={pageSize} value={pageSize === "all" ? data.length : pageSize}>
                                                Show {pageSize}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>}
                </div>
            </div>
        </div>
    );
}

export default ComboModelList;